<template>
  <div>
    <!-- Label -->
    <div v-if="label" class="label">{{ label }}</div>

    <!-- Select component -->
    <el-select
      v-model="selectedCostCenter"
      :disabled="!isDisabled"
      style="width: 100%"
      clearable
      @change="handleSelected"
    >
      <!-- Select Options component -->
      <el-option
        v-for="(t, idx) in options"
        :key="idx"
        :label="t.label"
        :value="t.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";

export default {
  props: {
    label: {
      type: String,
      default: '',
      required: false
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      selectedCostCenter: undefined,
      options: [
        { label: 'ทั้งหมด', value: undefined }
      ]
    }
  },
  created() {
    // Call fetch data on load page
    this.queryUniqueCostCenter()
  },
  methods: {
    handleSelected(val) {
      // Emit value to default v-model
      this.$emit('input', val)
    },
    async queryUniqueCostCenter() {
      // Define options
      this.options = [
        { label: 'ทั้งหมด', value: undefined },
      ]

      // Query Unique Cost Center
      await baanRueJaiClient.admin.redeem
        .getUniqueCostCenterFromTransaction()
        .then(response => {
          // Check result
          if (response.data.result.length > 0) {

            // Map result to filter options
            const options = response.data.result.map(code => ({
              label: code.cost_center,
              value: code.cost_center
            }))

            // Push map result to options
            this.options.push(...options)
          }
        })
    },
  }
}
</script>
